import axios from './axios'

class Course {
  // 点金列表
  getDianJinList(params, viewState) {
    return axios({
      url: '/DianJin/api/SearchList',
      method: 'post',
      headers: {
        'Ykt-ViewState': viewState
      },
      data: params
    })
  }
  // 课程列表
  getCourseList(params, viewState) {
    return axios({
      url: '/course/Subscribe/CourseList',
      method: 'post',
      headers: {
        'Ykt-ViewState': viewState
      },
      data: params
    })
  }
  // 解锁课包列表
  lookCourseList(params, viewState) {
    return axios({
      url: '/course/api/CourseSetList',
      method: 'post',
      headers: {
        'Ykt-ViewState': viewState
      },
      data: params
    })
  }

  // 解锁课程列表
  getUnlockCourseList(params, viewState) {
    return axios({
      url: '/course/Subscribe/CourseList',
      method: 'get',
      headers: {
        'Ykt-ViewState': viewState
      },
      params: { ...params }
    })
  }

  //创建解锁订单
  creteCouponOrder(params, viewState) {
    return axios({
      url: '/order/couponOrder/exchange',
      method: 'post',
      headers: {
        'Ykt-ViewState': viewState
      },
      data: params
    })
  }

  //查询解锁状态
  getExchangeResult(params, viewState) {
    return axios({
      url: '/order/couponOrder/getExchangeResult',
      method: 'get',
      headers: {
        'Ykt-ViewState': viewState
      },
      params: { ...params }
    })
  }
}

export default new Course()
